import { FC, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, DatePicker, Form, Input, message, Modal } from 'antd';
import * as React from 'react';
import { ROLE_TYPES } from '../../utils/DataConstants';
import OWForm from '../ow_form/OWForm';
import {
	getInvoiceNumber,
	invoicesRestCrudThunksForBuyer,
	invoicesRestCrudThunksForSupplier,
} from '../../thunks/invoices_thunks';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { getSanitisedWorkOrder } from '../../utils/WorkOrderUtils';
import { INVOICES_CRUD_ACTION_CREATORS } from '../../actions/invoices_actions';

const DATE_FORMAT = 'MM-DD-YYYY';

const InvoiceAddRequiredFieldsModal: FC<any> = ({
	ghost = false,
	invoice,
	updateInvoice,
	checkInvoiceNumber,
	type = 'default',
	style = { marginLeft: 12 },
}) => {
	const [form] = Form.useForm();
	const [showModal, setShowModal] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);

	const buttonProps = { style, ghost, type };

	const handleSubmit = (values) => {
		setSubmitLoading(true);
		updateInvoice({ ...invoice, ...values })
			.then(() => {
				message.success('Added Invoice Information.');
			})
			.catch((err) => message.error(err))
			.finally(() => {
				setSubmitLoading(false);
			});
	};

	const handleInvoiceNumberChange = async (rule, value) => {
		if (!value) {
			return Promise.resolve();
		}
		const data = await checkInvoiceNumber(
			value,
			nullSafeGet('supplierFacilityId', getSanitisedWorkOrder(nullSafeGet('workOrder', invoice)))
		);
		const isDuplicate = data.some(
			(other) => nullSafeGet('id', other) !== nullSafeGet('id', invoice)
		);

		if (isDuplicate) {
			return Promise.reject('Invoice number already exists');
		}
		return Promise.resolve();
	};

	return (
		<span>
			<Modal
				visible={showModal}
				width={600}
				title={'Add Required Invoice Information'}
				okText={'Submit'}
				onCancel={() => setShowModal(false)}
				onOk={form.submit}
				closable={true}
				destroyOnClose={true}
				confirmLoading={submitLoading}
			>
				<OWForm
					form={form}
					layout="vertical"
					className="addRequiredInvoiceInfoForm"
					preserve={false}
					initialValues={invoice}
					onFinish={handleSubmit}
					actionCreators={INVOICES_CRUD_ACTION_CREATORS}
				>
					{invoice.invoiceNumber ? null : (
						<Form.Item
							label="Invoice Number"
							name={'invoiceNumber'}
							validateTrigger="onBlur"
							rules={[
								{
									whitespace: true,
									required: true,
									message: 'This field is required.',
								},
								{ validator: handleInvoiceNumberChange },
							]}
						>
							<Input style={{ maxWidth: 320 }} />
						</Form.Item>
					)}
					{invoice.dateOfInvoice ? null : (
						<Form.Item
							label="Date of Invoice"
							name={'dateOfInvoice'}
							rules={[
								{
									required: true,
									message: 'Please select the invoice date',
								},
							]}
						>
							<DatePicker format={DATE_FORMAT} />
						</Form.Item>
					)}
				</OWForm>
			</Modal>
			<Button {...buttonProps} onClick={() => setShowModal(true)}>
				Add Required Info
			</Button>
		</span>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	updateInvoice: (invoice) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? invoicesRestCrudThunksForSupplier.update(invoice)
				: invoicesRestCrudThunksForBuyer.update(invoice)
		),
	checkInvoiceNumber: (invoice, supplierFacilityId) =>
		dispatch(getInvoiceNumber(invoice, supplierFacilityId)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(InvoiceAddRequiredFieldsModal)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
